export function getDate(inputDate) {
  const input = new Date(inputDate);
  const month = input.getMonth() + 1;
  const day = input.getDate();
  const year = input.getFullYear();
  const formatedDate = month + "/" + day + "/" + year;
  return formatedDate;
}
